(function() {
  'use strict';

  if (window.GEMSections && window.GEMSections.initialized) return;

  var GEM = {
    initialized: true,
    moneyFormat: "",

    formatMoney: function(cents, moneyFormat) {
      cents = parseInt(cents || 0, 10);
      var format = moneyFormat || GEM.moneyFormat;

      if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
        return window.Shopify.formatMoney(cents, format).replace(/^₹\s*/, '₹ ');
      }

      try {
        return new Intl.NumberFormat('en-IN', {
          style: 'currency',
          currency: 'INR',
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        }).format(cents / 100).replace(/^₹\s*/, '₹ ');
      } catch (e) {
        return '₹ ' + (cents / 100).toFixed(2);
      }
    },

    showMessage: function(el, message, isError) {
      if (!el) return;
      el.style.display = 'block';
      el.textContent = message;
      el.style.color = isError ? '#c00' : '#0a7a35';

      clearTimeout(el._timer);
      el._timer = setTimeout(function() {
        el.style.display = 'none';
      }, 2500);
    },

    notifyCartUpdated: function(data) {
      if (typeof window.globalcartcountupdate === 'function') {
        try { window.globalcartcountupdate(); } catch (_) {}
      }

      document.dispatchEvent(new CustomEvent('cart:updated', { detail: data }));
      document.dispatchEvent(new CustomEvent('cart:refresh'));
      window.dispatchEvent(new CustomEvent('cart:refresh'));
      document.dispatchEvent(new CustomEvent('ajaxProduct:added'));

      if (window.cartDrawer && typeof window.cartDrawer.refresh === 'function') {
        try { window.cartDrawer.refresh(); } catch (_) {}
      }
    },

    addToCart: function(variantId, quantity) {
      quantity = quantity || 1;

      var formData = new FormData();
      formData.append('id', variantId);
      formData.append('quantity', quantity);

      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json' },
        body: formData,
        credentials: 'same-origin'
      }).then(function(response) {
        if (!response.ok) throw new Error('Add to cart failed');
        return response.json();
      });
    },

    addToCartJson: function(variantId, quantity) {
      quantity = quantity || 1;

      return fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        credentials: 'same-origin',
        body: JSON.stringify({
          items: [{ id: Number(variantId), quantity: quantity }]
        })
      }).then(function(response) {
        if (!response.ok) {
          return response.json().then(function(err) { throw err; });
        }
        return response.json();
      });
    },

    getDefaultButtonHtml: function(textEl, button) {
      if (textEl) {
        if (!textEl.dataset.defaultHtml) {
          textEl.dataset.defaultHtml = textEl.innerHTML;
        }
        return textEl.dataset.defaultHtml;
      }

      if (button) {
        if (!button.dataset.defaultHtml) {
          button.dataset.defaultHtml = button.innerHTML;
        }
        return button.dataset.defaultHtml;
      }

      return '';
    },

    restoreButtonHtml: function(textEl, button, html) {
      if (textEl) {
        textEl.innerHTML = html;
      } else if (button) {
        button.innerHTML = html;
      }
    },


    setPaymentFormVariant: function(root, variantId, available) {
      if (!root || !variantId) return;

      var variantInput = root.querySelector('[data-gem-variant-input]');
      var paymentWrap = root.querySelector('[data-gem-payment-wrap]');

      if (variantInput) {
        variantInput.value = variantId;
      }

      GEM.updatePaymentAvailability(paymentWrap, available);
    },

    updatePaymentAvailability: function(paymentWrap, available) {
      if (!paymentWrap) return;

      var isAvailable = String(available) === 'true' || available === true;

      paymentWrap.classList.toggle('is-sold-out', !isAvailable);

      paymentWrap.querySelectorAll('button, [role="button"], input[type="submit"]').forEach(function(btn) {
        if (isAvailable) {
          btn.removeAttribute('disabled');
          btn.style.pointerEvents = '';
          btn.style.opacity = '';
        } else {
          btn.setAttribute('disabled', 'disabled');
          btn.style.pointerEvents = 'none';
          btn.style.opacity = '0.45';
        }
      });
    },

    runAddToCartButton: function(opts) {
      var button = opts.button;
      var textEl = opts.textEl;
      var variantId = opts.variantId;
      var messageEl = opts.messageEl;
      var successText = opts.successText || 'Added ✔';
      var loadingText = opts.loadingText || 'Adding...';
      var errorText = opts.errorText || 'Try again';
      var successMessage = opts.successMessage || 'Added to cart';
      var errorMessage = opts.errorMessage || 'Could not add to cart';
      var restoreDelay = opts.restoreDelay || 1500;
      var useJson = !!opts.useJson;
      var redirectToCart = !!opts.redirectToCart;

      if (!button || !variantId) {
        return Promise.reject(new Error('Missing button or variantId'));
      }

      var originalText = textEl ? textEl.innerHTML : button.innerHTML;

      button.classList.add('is-loading');
      button.disabled = true;

      if (textEl) {
        textEl.textContent = loadingText;
      } else {
        button.textContent = loadingText;
      }

      var request = useJson
        ? GEM.addToCartJson(variantId, 1)
        : GEM.addToCart(variantId, 1);

      return request.then(function(data) {
        button.classList.remove('is-loading');
        button.classList.add('is-success');
        button.disabled = false;

        if (textEl) {
          textEl.textContent = successText;
        } else {
          button.textContent = successText;
        }

        GEM.notifyCartUpdated(data);
        GEM.showMessage(messageEl, successMessage, false);

        if (redirectToCart) {
          window.location.href = '/cart';
          return data;
        }

        setTimeout(function() {
          button.classList.remove('is-success');
          GEM.restoreButtonHtml(textEl, button, originalText);
        }, restoreDelay);

        return data;
      }).catch(function(err) {
        console.error(err);

        button.classList.remove('is-loading');
        button.disabled = false;

        if (textEl) {
          textEl.textContent = errorText;
        } else {
          button.textContent = errorText;
        }

        var finalError = errorMessage;
        if (err && err.description) finalError = err.description;
        if (err && err.message && !err.description) finalError = err.message;

        GEM.showMessage(messageEl, finalError, true);

        setTimeout(function() {
          GEM.restoreButtonHtml(textEl, button, originalText);
        }, 1200);

        throw err;
      });
    },

    initHeroSections: function(context) {
      var roots = context.querySelectorAll('[id^="hero-"]');

      roots.forEach(function(root) {
        if (root.dataset.gemBound === 'true') return;
        root.dataset.gemBound = 'true';

        var sectionId = root.id.replace('hero-', '');

        var mainImage = document.getElementById('galleryMain-' + sectionId);
        var thumbs = root.querySelectorAll('.gallery-thumb');
        var packButtons = root.querySelectorAll('.pack-btn');
        var variantInput = document.getElementById('variantInput-' + sectionId);
        var addToCartBtn = document.getElementById('addToCartBtn-' + sectionId);
        var addToCartText = document.getElementById('addToCartText-' + sectionId);
        var buyNowBtn = document.getElementById('buyNowBtn-' + sectionId);
        var priceNow = document.getElementById('priceNow-' + sectionId);
        var priceWas = document.getElementById('priceWas-' + sectionId);
        var priceSave = document.getElementById('priceSave-' + sectionId);
        var pricePer = document.getElementById('pricePer-' + sectionId) || document.getElementById('heroPer-' + sectionId);
        var addToCartPrice = document.getElementById('addToCartPrice-' + sectionId);
        var cartMessage = document.getElementById('cartMessage-' + sectionId);
        var paymentWrap = root.querySelector('[data-gem-payment-wrap]');
        var paymentVariantInput = root.querySelector('[data-gem-variant-input]');

        var state = {
          selectedVariantId: variantInput ? variantInput.value : null
        };

        if (addToCartText) GEM.getDefaultButtonHtml(addToCartText, addToCartBtn);

        function updatePrice(price, comparePrice, priceNote, title) {
  price = parseInt(price || 0, 10);
  comparePrice = parseInt(comparePrice || 0, 10);

  if (priceNow) {
    priceNow.textContent = GEM.formatMoney(price);
  }

  if (addToCartPrice) {
    addToCartPrice.textContent = GEM.formatMoney(price);
  }

  if (pricePer) {
    pricePer.textContent = priceNote || title || '';
  }

  if (comparePrice > price) {
    if (priceWas) {
      priceWas.style.display = '';
      priceWas.textContent = GEM.formatMoney(comparePrice);
    }

    if (priceSave) {
      priceSave.style.display = '';
      priceSave.textContent = 'SAVE ' + GEM.formatMoney(comparePrice - price);
    }
  } else {
    if (priceWas) {
      priceWas.style.display = 'none';
      priceWas.textContent = '';
    }

    if (priceSave) {
      priceSave.style.display = 'none';
      priceSave.textContent = '';
    }
  }
}

 function updateAvailability(available, price) {
  var isAvailable = String(available) === 'true';

  if (addToCartBtn) {
    addToCartBtn.disabled = !isAvailable;
  }

  if (buyNowBtn) {
    buyNowBtn.disabled = !isAvailable;
  }

  if (addToCartText) {
    if (isAvailable) {
      GEM.restoreButtonHtml(
        addToCartText,
        addToCartBtn,
        GEM.getDefaultButtonHtml(addToCartText, addToCartBtn)
      );

      var liveAddToCartPrice = document.getElementById('addToCartPrice-' + sectionId);

      if (liveAddToCartPrice && price) {
        liveAddToCartPrice.textContent = GEM.formatMoney(price);
      }
    } else {
      addToCartText.textContent = 'Sold Out';
    }
  }
}

        function setMainImage(opts) {
          if (!mainImage || !opts) return;

          if (opts.src) {
            mainImage.src = opts.src;
          }

          if (opts.srcset) {
            mainImage.setAttribute('srcset', opts.srcset);
          } else {
            mainImage.removeAttribute('srcset');
          }

          if (opts.sizes) {
            mainImage.setAttribute('sizes', opts.sizes);
          } else {
            mainImage.removeAttribute('sizes');
          }

          if (opts.mediaId) {
            mainImage.setAttribute('data-media-id', opts.mediaId);
          }

          if (opts.alt) {
            mainImage.setAttribute('alt', opts.alt);
          }

          thumbs.forEach(function(thumb) {
            thumb.classList.toggle('active', String(thumb.dataset.mediaId) === String(opts.mediaId));
          });
        }

        function getActiveThumbIndex() {
          var activeIndex = 0;
          thumbs.forEach(function(thumb, index) {
            if (thumb.classList.contains('active')) activeIndex = index;
          });
          return activeIndex;
        }

        function activateThumbByIndex(index) {
          if (!thumbs.length) return;

          if (index < 0) index = thumbs.length - 1;
          if (index >= thumbs.length) index = 0;

          var thumb = thumbs[index];
          if (!thumb) return;

          setMainImage({
            src: thumb.dataset.full,
            srcset: thumb.dataset.srcset,
            sizes: thumb.dataset.sizes,
            mediaId: thumb.dataset.mediaId,
            alt: thumb.getAttribute('alt')
          });
        }

        function selectPack(button) {
          packButtons.forEach(function(btn) {
            btn.classList.remove('selected');
          });

          button.classList.add('selected');

          var variantId = button.dataset.variantId;
var price = button.dataset.price;
var comparePrice = button.dataset.comparePrice;
var available = button.dataset.available;
var title = button.dataset.title;
var priceNote = button.dataset.priceNote;
var featuredMedia = button.dataset.featuredMedia;
var featuredMediaSrcset = button.dataset.featuredMediaSrcset;
var featuredMediaSizes = button.dataset.featuredMediaSizes;
var featuredMediaId = button.dataset.featuredMediaId;

state.selectedVariantId = variantId;



if (variantInput) {
  variantInput.value = variantId;
}

if (addToCartBtn) {
  addToCartBtn.setAttribute('data-variant-id', variantId);
}

if (buyNowBtn) {
  buyNowBtn.setAttribute('data-variant-id', variantId);
}

if (paymentVariantInput) {
  paymentVariantInput.value = variantId;
}
GEM.setPaymentFormVariant(root, variantId, available);


updatePrice(price, comparePrice, priceNote, title);
updateAvailability(available, price);

          if (featuredMedia && mainImage) {
            setMainImage({
              src: featuredMedia,
              srcset: featuredMediaSrcset,
              sizes: featuredMediaSizes,
              mediaId: featuredMediaId
            });
          } else if (featuredMediaId) {
            thumbs.forEach(function(thumb) {
              thumb.classList.toggle('active', thumb.dataset.mediaId === featuredMediaId);
            });
          }
        }

        thumbs.forEach(function(thumb) {
          thumb.addEventListener('click', function() {
            setMainImage({
              src: this.dataset.full,
              srcset: this.dataset.srcset,
              sizes: this.dataset.sizes,
              mediaId: this.dataset.mediaId,
              alt: this.getAttribute('alt')
            });
          });
        });

        if (mainImage && thumbs.length > 1) {
          var touchStartX = 0;
          var touchStartY = 0;
          var touchEndX = 0;
          var touchEndY = 0;
          var minSwipeDistance = 40;

          mainImage.addEventListener('touchstart', function(e) {
            var touch = e.changedTouches[0];
            touchStartX = touch.clientX;
            touchStartY = touch.clientY;
          }, { passive: true });

          mainImage.addEventListener('touchend', function(e) {
            var touch = e.changedTouches[0];
            touchEndX = touch.clientX;
            touchEndY = touch.clientY;

            var deltaX = touchEndX - touchStartX;
            var deltaY = touchEndY - touchStartY;

            if (Math.abs(deltaX) < minSwipeDistance) return;
            if (Math.abs(deltaX) < Math.abs(deltaY)) return;

            var currentIndex = getActiveThumbIndex();

            if (deltaX < 0) {
              activateThumbByIndex(currentIndex + 1);
            } else {
              activateThumbByIndex(currentIndex - 1);
            }
          }, { passive: true });
        }

        packButtons.forEach(function(button) {
          button.addEventListener('click', function() {
            selectPack(this);
          });
        });

        if (addToCartBtn) {
          addToCartBtn.addEventListener('click', function(e) {
            e.preventDefault();
            if (!state.selectedVariantId) return;

            GEM.runAddToCartButton({
              button: addToCartBtn,
              textEl: addToCartText,
              variantId: state.selectedVariantId,
              messageEl: cartMessage,
              successMessage: 'Added to cart'
            });
          });
        }

        if (buyNowBtn) {
          buyNowBtn.addEventListener('click', function(e) {
            e.preventDefault();
            if (!state.selectedVariantId) return;

            var original = GEM.getDefaultButtonHtml(null, buyNowBtn);

            buyNowBtn.classList.add('is-loading');
            buyNowBtn.textContent = 'Processing...';
            buyNowBtn.disabled = true;

            GEM.addToCart(state.selectedVariantId, 1).then(function(data) {
              GEM.notifyCartUpdated(data);
              window.location.href = '/cart';
            }).catch(function(err) {
              console.error(err);
              GEM.showMessage(cartMessage, 'Could not add item. Please try again.', true);
              buyNowBtn.textContent = 'Try again';

              setTimeout(function() {
                GEM.restoreButtonHtml(null, buyNowBtn, original);
              }, 1200);
            }).finally(function() {
              buyNowBtn.classList.remove('is-loading');
              buyNowBtn.disabled = false;
            });
          });
        }
      });
    },

    initScienceSections: function(context) {
  var roots = context.querySelectorAll('[id^="science-section-"]');

  roots.forEach(function(root) {
    if (root.dataset.gemBound === 'true') return;
    root.dataset.gemBound = 'true';

    var sectionId = root.id.replace('science-section-', '');
    var atcBtn = document.getElementById('scienceAddToCartBtn-' + sectionId);
    var atcText = document.getElementById('scienceAddToCartText-' + sectionId);
    var cartMessage = document.getElementById('scienceCartMessage-' + sectionId);
    var packButtons = root.querySelectorAll('.desc-pack-btn');
    var paymentWrap = root.querySelector('[data-gem-payment-wrap]');
    var paymentVariantInput = root.querySelector('[data-gem-variant-input]');

    if (!packButtons.length) return;

    var soldOutText = root.dataset.soldOutText || 'Sold Out';

    if (atcText && atcBtn) {
      GEM.getDefaultButtonHtml(atcText, atcBtn);
    }

    var initialSelected = root.querySelector('.desc-pack-btn.selected');
    var state = {
      selectedVariantId: atcBtn
        ? atcBtn.getAttribute('data-variant-id')
        : paymentVariantInput
          ? paymentVariantInput.value
          : initialSelected
            ? initialSelected.getAttribute('data-variant-id')
            : ''
    };

    function setButtonText(available) {
      if (!atcText) return;

      if (!available) {
        atcText.textContent = soldOutText;
        return;
      }

      atcText.textContent = 'Start My Protocol';

      if (atcBtn) {
        GEM.getDefaultButtonHtml(atcText, atcBtn);
      }
    }

    function selectVariant(button) {
      if (!button || button.disabled || button.getAttribute('data-available') !== 'true') return;

      packButtons.forEach(function(btn) {
        btn.classList.remove('selected');
        btn.setAttribute('aria-pressed', 'false');
      });

      button.classList.add('selected');
      button.setAttribute('aria-pressed', 'true');

      var variantId = button.getAttribute('data-variant-id');
      var available = button.getAttribute('data-available') === 'true';

      state.selectedVariantId = variantId;

      if (atcBtn) {
        atcBtn.setAttribute('data-variant-id', variantId);
        atcBtn.disabled = !available;
      }

      if (paymentVariantInput) {
        paymentVariantInput.value = variantId;
      }

      GEM.setPaymentFormVariant(root, variantId, available);
      setButtonText(available);
    }

    packButtons.forEach(function(button) {
      button.addEventListener('click', function() {
        selectVariant(this);
      });
    });

    if (atcBtn) {
      atcBtn.addEventListener('click', function(e) {
        e.preventDefault();
        if (!state.selectedVariantId) return;

        GEM.runAddToCartButton({
          button: atcBtn,
          textEl: atcText,
          variantId: state.selectedVariantId,
          messageEl: cartMessage,
          successMessage: 'Added to cart'
        });
      });
    }

    if (initialSelected) {
      GEM.setPaymentFormVariant(
        root,
        initialSelected.getAttribute('data-variant-id'),
        initialSelected.getAttribute('data-available') === 'true'
      );
    }
  });
},

    initQuizSections: function(context) {
      var roots = context.querySelectorAll('[id^="gem-quiz-"]');

      roots.forEach(function(root) {
        if (root.dataset.gemBound === 'true') return;
        root.dataset.gemBound = 'true';

        var sectionId = root.id.replace('gem-quiz-', '');
        var dataEl = document.getElementById('quizRecommendationsData-' + sectionId);
        var quizData = { default_key: '', recommendations: {} };

        try {
          quizData = JSON.parse(dataEl.textContent);
        } catch (e) {
          console.error('Quiz recommendation JSON parse error', e);
        }

        var steps = root.querySelectorAll('.quiz-step');
        var result = document.getElementById('quizResult-' + sectionId);
        var optionButtons = root.querySelectorAll('.quiz-opt');
        var resetBtn = document.getElementById('quizResetBtn-' + sectionId);
        var ctaBtn = document.getElementById('quizCtaBtn-' + sectionId);
        var ctaText = document.getElementById('quizCtaText-' + sectionId);
        var resultHeading = document.getElementById('quizResultHeading-' + sectionId);
        var resultText = document.getElementById('quizResultText-' + sectionId);
        var variantToggle = document.getElementById('quizVariantToggle-' + sectionId);
        var messageEl = document.getElementById('quizMessage-' + sectionId);

        var fallbackCtaText = root.dataset.ctaFallbackText || 'Add to Cart';
        var defaultResultHeading = root.dataset.defaultResultHeading || '';

        if (ctaText) GEM.getDefaultButtonHtml(ctaText, ctaBtn);

        var state = {
          q1: '',
          q2: '',
          q3: '',
          recommendationKey: result ? (result.getAttribute('data-default-recommendation-key') || '') : '',
          selectedVariantId: ''
        };

        function hideAllSteps() {
          steps.forEach(function(step) {
            step.classList.remove('active');
          });
        }

        function showStep(index) {
          hideAllSteps();
          if (result) result.classList.remove('active');

          var step = document.getElementById('q' + index + '-' + sectionId);
          if (step) step.classList.add('active');
        }

        function getRecommendation(key) {
          if (key && quizData.recommendations && quizData.recommendations[key]) {
            return quizData.recommendations[key];
          }

          if (quizData.default_key && quizData.recommendations && quizData.recommendations[quizData.default_key]) {
            return quizData.recommendations[quizData.default_key];
          }

          var allKeys = Object.keys(quizData.recommendations || {});
          return allKeys.length ? quizData.recommendations[allKeys[0]] : null;
        }

        function renderVariantButtons(recommendation) {
          if (!variantToggle) return;

          var availableVariants = (recommendation.variants || []).filter(function(v) {
            return !!v.available;
          });

          if (!recommendation.show_variant_selector || availableVariants.length <= 1) {
            variantToggle.style.display = 'none';
            variantToggle.innerHTML = '';
            return;
          }

          variantToggle.style.display = '';
          variantToggle.innerHTML = availableVariants.map(function(variant) {
            var isSelected = String(variant.id) === String(state.selectedVariantId);
            return ''
              + '<button type="button" class="quiz-variant-btn' + (isSelected ? ' selected' : '') + '"'
              + ' data-variant-id="' + variant.id + '"'
              + ' data-price="' + variant.price + '"'
              + ' data-available="' + (variant.available ? 'true' : 'false') + '">'
              + variant.title
              + '<strong>' + GEM.formatMoney(variant.price) + '</strong>'
              + '</button>';
          }).join('');

          variantToggle.querySelectorAll('.quiz-variant-btn').forEach(function(button) {
            button.addEventListener('click', function() {
              variantToggle.querySelectorAll('.quiz-variant-btn').forEach(function(btn) {
                btn.classList.remove('selected');
              });

              this.classList.add('selected');

              var variantId = this.getAttribute('data-variant-id');
              var price = this.getAttribute('data-price');
              var available = this.getAttribute('data-available') === 'true';

              state.selectedVariantId = variantId;
              ctaBtn.setAttribute('data-variant-id', variantId);
              ctaBtn.disabled = !available;

              if (ctaText) {
                var ctaLabel = recommendation.cta_text || fallbackCtaText;
                ctaText.innerHTML = available
                  ? ctaLabel + ' — ' + GEM.formatMoney(price) + ' <span class="arrow">→</span>'
                  : 'Sold Out';

                if (available) {
                  GEM.getDefaultButtonHtml(ctaText, ctaBtn);
                }
              }
            });
          });
        }

        function renderRecommendation() {
          var recommendation = getRecommendation(state.recommendationKey);
          if (!recommendation) return;

          var defaultVariant = null;

          if (recommendation.default_variant_id) {
            defaultVariant = (recommendation.variants || []).find(function(v) {
              return String(v.id) === String(recommendation.default_variant_id);
            });
          }

          if (!defaultVariant) {
            defaultVariant = (recommendation.variants || []).find(function(v) {
              return !!v.available;
            }) || (recommendation.variants || [])[0];
          }

          if (!defaultVariant) return;

          state.selectedVariantId = defaultVariant.id;

          if (resultHeading) {
            resultHeading.textContent = recommendation.heading || defaultResultHeading;
          }

          if (resultText) {
            resultText.innerHTML = recommendation.text || '';
          }

          if (ctaBtn) {
            ctaBtn.setAttribute('data-variant-id', defaultVariant.id);
            ctaBtn.disabled = !defaultVariant.available;
          }

          if (ctaText) {
            var ctaLabel = recommendation.cta_text || fallbackCtaText;
            ctaText.innerHTML = defaultVariant.available
              ? ctaLabel + ' — ' + GEM.formatMoney(defaultVariant.price) + ' <span class="arrow">→</span>'
              : 'Sold Out';

            if (defaultVariant.available) {
              GEM.getDefaultButtonHtml(ctaText, ctaBtn);
            }
          }

          renderVariantButtons(recommendation);
        }

        function showResult() {
          hideAllSteps();
          renderRecommendation();
          if (result) result.classList.add('active');
        }

        function resetQuiz() {
          state.q1 = '';
          state.q2 = '';
          state.q3 = '';
          state.recommendationKey = result ? (result.getAttribute('data-default-recommendation-key') || '') : '';
          state.selectedVariantId = '';

          optionButtons.forEach(function(btn) {
            btn.classList.remove('selected');
          });

          if (variantToggle) {
            variantToggle.innerHTML = '';
            variantToggle.style.display = 'none';
          }

          if (resultHeading) resultHeading.textContent = '';
          if (resultText) resultText.innerHTML = '';
          if (result) result.classList.remove('active');

          showStep(1);
        }

        optionButtons.forEach(function(btn) {
          btn.addEventListener('click', function() {
            var question = this.getAttribute('data-question');
            var value = this.getAttribute('data-value');
            var recommendationKey = this.getAttribute('data-recommendation-key');
            var currentStep = this.closest('.quiz-step');
            if (!currentStep) return;

            currentStep.querySelectorAll('.quiz-opt').forEach(function(opt) {
              opt.classList.remove('selected');
            });

            this.classList.add('selected');

            if (question === '1') {
              state.q1 = value;
              if (recommendationKey) state.recommendationKey = recommendationKey;
            } else if (question === '2') {
              state.q2 = value;
            } else if (question === '3') {
              state.q3 = value;
            }

            setTimeout(function() {
              if (question === '1') showStep(2);
              else if (question === '2') showStep(3);
              else showResult();
            }, 280);
          });
        });

        if (resetBtn) {
          resetBtn.addEventListener('click', resetQuiz);
        }

        if (ctaBtn) {
          ctaBtn.addEventListener('click', function(e) {
            e.preventDefault();
            if (!state.selectedVariantId) return;

            GEM.runAddToCartButton({
              button: ctaBtn,
              textEl: ctaText,
              variantId: state.selectedVariantId,
              messageEl: messageEl,
              successMessage: 'Added to cart'
            });
          });
        }
      });
    },

    initDescriptionSections: function(context) {
  var roots = context.querySelectorAll('[id^="gem-product-description-"]');

  roots.forEach(function(root) {
    if (root.dataset.gemBound === 'true') return;
    root.dataset.gemBound = 'true';

    var sectionId = root.id.replace('gem-product-description-', '');
    var atcBtn = document.getElementById('descAddToCartBtn-' + sectionId);
    var atcText = document.getElementById('descAddToCartText-' + sectionId);
    var priceEl = document.getElementById('descVariantPrice-' + sectionId);
    var cartMessage = document.getElementById('descCartMessage-' + sectionId);
    var packButtons = root.querySelectorAll('.desc-pack-btn');
    var paymentWrap = root.querySelector('[data-gem-payment-wrap]');
    var paymentVariantInput = root.querySelector('[data-gem-variant-input]');

    if (!packButtons.length) return;

    if (atcText && atcBtn) {
      GEM.getDefaultButtonHtml(atcText, atcBtn);
    }

    var initialSelected = root.querySelector('.desc-pack-btn.selected');
    var state = {
      selectedVariantId: atcBtn
        ? atcBtn.getAttribute('data-variant-id')
        : paymentVariantInput
          ? paymentVariantInput.value
          : initialSelected
            ? initialSelected.getAttribute('data-variant-id')
            : ''
    };

    function selectVariant(button) {
      if (!button || button.disabled || button.getAttribute('data-available') !== 'true') return;

      packButtons.forEach(function(btn) {
        btn.classList.remove('selected');
      });

      button.classList.add('selected');

      var variantId = button.getAttribute('data-variant-id');
      var price = button.getAttribute('data-price');
      var priceNote = button.getAttribute('data-price-note');
      var available = button.getAttribute('data-available') === 'true';

      state.selectedVariantId = variantId;

      if (paymentVariantInput) {
        paymentVariantInput.value = variantId;
      }

      GEM.setPaymentFormVariant(root, variantId, available);

      if (atcBtn) {
        atcBtn.setAttribute('data-variant-id', variantId);
        atcBtn.disabled = !available;
      }

      if (priceEl) {
        priceEl.textContent = priceNote || GEM.formatMoney(price);
      }

      if (atcText) {
        if (available) {
          GEM.restoreButtonHtml(
            atcText,
            atcBtn,
            GEM.getDefaultButtonHtml(atcText, atcBtn)
          );

          var livePriceEl = document.getElementById('descVariantPrice-' + sectionId);
          if (livePriceEl) {
            livePriceEl.textContent = priceNote || GEM.formatMoney(price);
          }
        } else {
          atcText.textContent = 'Sold Out';
        }
      }
    }

    packButtons.forEach(function(button) {
      button.addEventListener('click', function() {
        selectVariant(this);
      });
    });

    if (atcBtn) {
      atcBtn.addEventListener('click', function(e) {
        e.preventDefault();
        if (!state.selectedVariantId) return;

        GEM.runAddToCartButton({
          button: atcBtn,
          textEl: atcText,
          variantId: state.selectedVariantId,
          messageEl: cartMessage,
          successMessage: 'Added to cart'
        });
      });
    }

    if (initialSelected) {
      GEM.setPaymentFormVariant(
        root,
        initialSelected.getAttribute('data-variant-id'),
        initialSelected.getAttribute('data-available') === 'true'
      );
    }
  });
},

    initSingleAtcButtons: function(context) {
      var configs = [
        {
          buttonPrefix: 'whoNeedsAtcBtn-',
          textPrefix: 'whoNeedsAtcText-',
          msgPrefix: 'whoNeedsCartMessage-',
          redirectToCart: true
        },
        {
          buttonPrefix: 'mfgAddToCartBtn-',
          textPrefix: 'mfgAddToCartText-',
          msgPrefix: 'mfgCartMessage-',
          redirectToCart: true
        }
      ];

      configs.forEach(function(cfg) {
        var buttons = context.querySelectorAll('[id^="' + cfg.buttonPrefix + '"]');

        buttons.forEach(function(atcBtn) {
          if (atcBtn.dataset.gemBound === 'true') return;
          atcBtn.dataset.gemBound = 'true';

          var sectionId = atcBtn.id.replace(cfg.buttonPrefix, '');
          var atcText = document.getElementById(cfg.textPrefix + sectionId);
          var cartMessage = document.getElementById(cfg.msgPrefix + sectionId);

          if (atcText) GEM.getDefaultButtonHtml(atcText, atcBtn);

          atcBtn.addEventListener('click', function(e) {
            e.preventDefault();

            var variantId = atcBtn.getAttribute('data-variant-id');
            if (!variantId) return;

            GEM.runAddToCartButton({
              button: atcBtn,
              textEl: atcText,
              variantId: variantId,
              messageEl: cartMessage,
              successMessage: 'Added to cart',
              redirectToCart: cfg.redirectToCart
            });
          });
        });
      });

      var videoThumbs = context.querySelectorAll('[id^="mfgVideoThumb-"]');
      videoThumbs.forEach(function(videoThumb) {
        if (videoThumb.dataset.gemBound === 'true') return;
        videoThumb.dataset.gemBound = 'true';

        var sectionId = videoThumb.id.replace('mfgVideoThumb-', '');
        var videoPlayer = document.getElementById('mfgVideoPlayer-' + sectionId);

        if (!videoPlayer) return;

        videoThumb.addEventListener('click', function() {
          videoThumb.style.display = 'none';
          videoPlayer.style.display = 'block';
          try { videoPlayer.play(); } catch (e) { console.error(e); }
        });
      });
    },

    initFinalCtaSections: function(context) {
  var roots = context.querySelectorAll('[id^="gem-final-cta-"]');

  roots.forEach(function(root) {
    if (root.dataset.gemBound === 'true') return;
    root.dataset.gemBound = 'true';

    var sectionId = root.id.replace('gem-final-cta-', '');
    var ctaBtn = document.getElementById('finalCtaBtn-' + sectionId);
    var ctaBtnText = document.getElementById('finalCtaBtnText-' + sectionId);
    var ctaPrice = document.getElementById('finalCtaPrice-' + sectionId);
    var messageEl = document.getElementById('finalCtaMessage-' + sectionId);
    var variantButtons = root.querySelectorAll('.final-cta-variant-btn');
    var paymentWrap = root.querySelector('[data-gem-payment-wrap]');
    var paymentVariantInput = root.querySelector('[data-gem-variant-input]');

    if (!variantButtons.length) return;

    if (ctaBtnText && ctaBtn) {
      GEM.getDefaultButtonHtml(ctaBtnText, ctaBtn);
    }

    var initialSelected = root.querySelector('.final-cta-variant-btn.selected');
    var state = {
      selectedVariantId: ctaBtn
        ? ctaBtn.getAttribute('data-variant-id')
        : paymentVariantInput
          ? paymentVariantInput.value
          : initialSelected
            ? initialSelected.getAttribute('data-variant-id')
            : ''
    };

    function updateVariant(variantId, price, available, clickedBtn) {
      var isAvailable = String(available) === 'true';

      state.selectedVariantId = variantId;

      if (paymentVariantInput) {
        paymentVariantInput.value = variantId;
      }

      GEM.setPaymentFormVariant(root, variantId, isAvailable);

      if (ctaBtn) {
        ctaBtn.setAttribute('data-variant-id', variantId);
        ctaBtn.disabled = !isAvailable;
      }

      if (ctaPrice && price) {
        ctaPrice.textContent = GEM.formatMoney(price);
      }

      variantButtons.forEach(function(btn) {
        btn.classList.remove('selected');
      });

      if (clickedBtn) clickedBtn.classList.add('selected');

      if (ctaBtnText) {
        if (isAvailable) {
          GEM.restoreButtonHtml(
            ctaBtnText,
            ctaBtn,
            GEM.getDefaultButtonHtml(ctaBtnText, ctaBtn)
          );

          if (ctaPrice && price) {
            ctaPrice.textContent = GEM.formatMoney(price);
          }
        } else {
          ctaBtnText.textContent = 'Sold Out';
        }
      }
    }

    variantButtons.forEach(function(button) {
      button.addEventListener('click', function() {
        updateVariant(
          this.getAttribute('data-variant-id'),
          this.getAttribute('data-price'),
          this.getAttribute('data-available'),
          this
        );
      });
    });

    if (ctaBtn) {
      ctaBtn.addEventListener('click', function(e) {
        e.preventDefault();
        if (!state.selectedVariantId) return;

        GEM.runAddToCartButton({
          button: ctaBtn,
          textEl: ctaBtnText,
          variantId: state.selectedVariantId,
          messageEl: messageEl,
          successMessage: 'Added to cart'
        });
      });
    }

    if (initialSelected) {
      GEM.setPaymentFormVariant(
        root,
        initialSelected.getAttribute('data-variant-id'),
        initialSelected.getAttribute('data-available') === 'true'
      );
    }
  });
},

    initBundleSaveSections: function(context) {
      var roots = context.querySelectorAll('[id^="gem-bundle-save-"]');

      roots.forEach(function(root) {
        if (root.dataset.gemBound === 'true') return;
        root.dataset.gemBound = 'true';

        var sectionId = root.id.replace('gem-bundle-save-', '');
        var bundleCards = root.querySelectorAll('.bundle-card');

        bundleCards.forEach(function(card) {
          if (card.dataset.gemBound === 'true') return;
          card.dataset.gemBound = 'true';

          var variantButtons = card.querySelectorAll('.bundle-variant-btn');
          var atcBtn = card.querySelector('.bundleAddToCartBtn');
          if (!atcBtn) return;

          var cardId = atcBtn.id.replace('bundleAddToCartBtn-' + sectionId + '-', '');
          var atcText = document.getElementById('bundleAddToCartText-' + sectionId + '-' + cardId);
          var ctaPrice = document.getElementById('bundleCtaPrice-' + sectionId + '-' + cardId);
          var priceNow = document.getElementById('bundlePriceNow-' + sectionId + '-' + cardId);
          var priceWas = document.getElementById('bundlePriceWas-' + sectionId + '-' + cardId);
          var priceSave = document.getElementById('bundlePriceSave-' + sectionId + '-' + cardId);
          var saveBadge = document.getElementById('bundleSaveBadge-' + sectionId + '-' + cardId);
          var cartMessage = document.getElementById('bundleCartMessage-' + sectionId + '-' + cardId);
          var paymentWrap = card.querySelector('[data-gem-payment-wrap]');
          var paymentVariantInput = card.querySelector('[data-gem-variant-input]');

          if (atcText) GEM.getDefaultButtonHtml(atcText, atcBtn);

          var state = {
            selectedVariantId: atcBtn.getAttribute('data-variant-id')
          };

          function updatePriceUI(price, comparePrice) {
            price = parseInt(price || 0, 10);
            comparePrice = parseInt(comparePrice || 0, 10);

            if (ctaPrice) ctaPrice.textContent = GEM.formatMoney(price);
            if (priceNow) priceNow.textContent = GEM.formatMoney(price);

            if (comparePrice > price) {
              var diff = comparePrice - price;

              if (priceWas) {
                priceWas.style.display = '';
                priceWas.textContent = GEM.formatMoney(comparePrice);
              }

              if (priceSave) {
                priceSave.style.display = '';
                priceSave.textContent = 'Save ' + GEM.formatMoney(diff);
              }

              if (saveBadge) {
                saveBadge.textContent = 'SAVE ' + GEM.formatMoney(diff);
              }
            } else {
              if (priceWas) {
                priceWas.style.display = 'none';
                priceWas.textContent = '';
              }
              if (priceSave) {
                priceSave.style.display = 'none';
                priceSave.textContent = '';
              }
            }
          }

          function updateAvailability(available, price) {
            var isAvailable = String(available) === 'true';
            atcBtn.disabled = !isAvailable;

            if (atcText) {
              if (isAvailable) {
                GEM.restoreButtonHtml(atcText, atcBtn, GEM.getDefaultButtonHtml(atcText, atcBtn));

                var liveBundlePriceEl = document.getElementById('bundleCtaPrice-' + sectionId + '-' + cardId);
                if (liveBundlePriceEl) {
                  liveBundlePriceEl.textContent = GEM.formatMoney(price);
                }
              } else {
                atcText.textContent = 'Sold Out';
              }
            }
          }

          variantButtons.forEach(function(btn) {
            btn.addEventListener('click', function() {
              variantButtons.forEach(function(b) {
                b.classList.remove('selected');
              });

              this.classList.add('selected');

              var variantId = this.getAttribute('data-variant-id');
              var price = this.getAttribute('data-price');
              var comparePrice = this.getAttribute('data-compare-price');
              var available = this.getAttribute('data-available');

              state.selectedVariantId = variantId;
              atcBtn.setAttribute('data-variant-id', variantId);

              updatePriceUI(price, comparePrice);
              updateAvailability(available, price);
            });
          });

          atcBtn.addEventListener('click', function(e) {
            e.preventDefault();
            if (!state.selectedVariantId) return;

            GEM.runAddToCartButton({
              button: atcBtn,
              textEl: atcText,
              variantId: state.selectedVariantId,
              messageEl: cartMessage,
              successMessage: 'Added to cart'
            });
          });
        });
      });
    },

    initCourseBundleSections: function(context) {
      var roots = context.querySelectorAll('[id^="gem-course-bundle-"]');

      roots.forEach(function(root) {
        if (root.dataset.gemBound === 'true') return;
        root.dataset.gemBound = 'true';

        root.querySelectorAll('[data-card-root]').forEach(function(card) {
          if (card.dataset.gemBound === 'true') return;
          card.dataset.gemBound = 'true';

         var atcBtn = card.querySelector('[data-atc-btn]');
var atcText = card.querySelector('[data-atc-text]');
var msgEl = card.querySelector('[data-msg]');
var paymentWrap = card.querySelector('[data-gem-payment-wrap]');
var paymentVariantInput = card.querySelector('[data-gem-variant-input]');
var variantId = card.getAttribute('data-variant-id');
var isAvailable = true;

if (atcBtn) {
  isAvailable = !atcBtn.disabled;
}

if (paymentVariantInput && variantId) {
  paymentVariantInput.value = variantId;
}

GEM.updatePaymentAvailability(paymentWrap, isAvailable);

if (!atcBtn) return;

if (atcText) GEM.getDefaultButtonHtml(atcText, atcBtn);

atcBtn.addEventListener('click', function() {
  if (atcBtn.disabled) return;

  var variantId = atcBtn.getAttribute('data-variant-id');

  GEM.runAddToCartButton({
    button: atcBtn,
    textEl: atcText,
    variantId: variantId,
    messageEl: msgEl,
    successText: 'Added ✓',
    successMessage: 'Added to cart',
    errorMessage: 'Something went wrong',
    useJson: true,
    restoreDelay: 1200
  });
});
        });
      });
    },

    initAll: function(context) {
      context = context || document;
      GEM.initHeroSections(context);
      GEM.initScienceSections(context);
      GEM.initQuizSections(context);
      GEM.initDescriptionSections(context);
      GEM.initSingleAtcButtons(context);
      GEM.initFinalCtaSections(context);
      GEM.initBundleSaveSections(context);
      GEM.initCourseBundleSections(context);
    }
  };

  window.GEMSections = GEM;
  window.formatShopMoney = window.formatShopMoney || GEM.formatMoney;

  function runInit(context) {
    GEM.initAll(context || document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      runInit(document);
    });
  } else {
    runInit(document);
  }

  document.addEventListener('shopify:section:load', function(e) {
    setTimeout(function() {
      runInit(e.target || document);
    }, 100);
  });
})();